// extracted by mini-css-extract-plugin
export default {"clearpayIcon":"pay-later-category_clearpayIcon__dc113","klarnaIcon":"pay-later-category_klarnaIcon__30bb6"};